import * as THREE from 'three'
import {SectionBase} from "./SectionBase.js";

export default class UmsetzungSection extends SectionBase
{
    constructor(_options)
    {
        super(_options);
    }

    setGeometries()
    {
        this.geometries = {}
        this.geometries.floor = new THREE.PlaneGeometry(16, 8)
    }

    setMeshes()
    {
        this.meshes = {}

        // this.meshes.boardStructure = this.objects.getConvertedMesh(this.resources.items.projectsBoardStructure.scene.children, { floorShadowTexture: this.resources.items.projectsBoardStructureFloorShadowTexture })
        this.resources.items.areaOpenTexture.magFilter = THREE.NearestFilter
        this.resources.items.areaOpenTexture.minFilter = THREE.LinearFilter
        this.meshes.boardPlane = this.resources.items.projectsBoardPlane.scene.children[0]
        this.meshes.areaLabel = new THREE.Mesh(new THREE.PlaneGeometry(2, 0.5), new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.resources.items.areaOpenTexture }))
        this.meshes.areaLabel.matrixAutoUpdate = false
    }

    setItemConfigs()
    {
        this.list = [
            {
                name: 'priorHoldings',
                x: 155,
                y: -30,
                cameraAngle: 'projects',
                interactionTypes: ['showTexture'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/priorHoldings/slideA.jpg',
                        './models/projects/priorHoldings/slideB.jpg',
                        './models/projects/priorHoldings/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsOranoFloorTexture,
                floorTextureOffsetX:-6,
                link:
                    {
                        href: 'https://prior.co.jp/discover/',
                        x: - 4.8,
                        y: - 3,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [

                    ]
            },
            {
                name: 'orano',
                x: 170,
                y: -22,
                interactionTypes: ['wiederstand'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/orano/slideA.jpg',
                        './models/projects/orano/slideB.jpg',
                        './models/projects/orano/slideC.jpg'
                    ],
                link:
                    {
                        href: 'https://orano.imm-g-prod.com/experience/innovation/en',
                        x: - 4.8,
                        y: - 3.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [
                        {type: 'Umsetzungg', x: -6, y: -12 },
                    ]
            },
            {
                name: 'citrixRedbull',
                cameraAngle: 'projects',
                x: 170,
                y: -38,
                interactionTypes: ['showTexture'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/citrixRedbull/slideA.jpg',
                        './models/projects/citrixRedbull/slideB.jpg',
                        './models/projects/citrixRedbull/slideC.jpg'
                    ],
                floorTextureLeft:this.resources.items.projectsCitrixRedbullFloorTexture,
                link:
                    {
                        href: 'https://thenewmobileworkforce.imm-g-prod.com/',
                        x: - 4.8,
                        y: - 4.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [

                    ]
            },
            {
                name: 'gleecChat',
                x: 185,
                y: -30,
                interactionTypes: ['showQuizOverlay'],
                useTiles: true,
                imageSources:
                    [
                        './models/projects/gleecChat/slideA.jpg',
                        './models/projects/gleecChat/slideB.jpg',
                        './models/projects/gleecChat/slideC.jpg'
                    ],
                floorTexture: this.resources.items.projectsGleecChatFloorTexture,
                link:
                    {
                        href: 'http://gleec.imm-g-prod.com',
                        x: - 4.8,
                        y: - 3.4,
                        halfExtents:
                            {
                                x: 3.2,
                                y: 1.5
                            }
                    },
                distinctions:
                    [

                    ]
            },
        ]
    }

    setRoads() {
        let roads;
        roads = [
            {
                start: new THREE.Vector2(127, -32),
                delta: new THREE.Vector2(15, 1)
            },
            {
                start: new THREE.Vector2(147,-30),
                delta: new THREE.Vector2(14, 3)
            },
            {
                start: new THREE.Vector2(170,-28),
                delta: new THREE.Vector2(8,-5)
            },
            {
                start: new THREE.Vector2(156,-38),
                delta: new THREE.Vector2(4,-3)
            },
            {
                start: new THREE.Vector2(178,-32),
                delta: new THREE.Vector2(25,0)
            },
            {
                start: new THREE.Vector2(177,-38),
                delta: new THREE.Vector2(-3,-6)
            }
        ]
        roads.forEach(road => {
            this.tiles.add({
                start: road.start,
                delta: road.delta
            })
        })
    }

    setStatic() {
    }

    setWalls() {
        super.setWalls();

        this.walls.add({
            object:
                {
                    ...this.dikes.brickOptions,
                    rotation: new THREE.Euler(0, 0, Math.PI * 0.5)
                },
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 28, this.y + 10, 0),
                    offsetWidth: new THREE.Vector3(1.05, 0, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: false,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x + 29.9, this.y + 11, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object:
                {
                    ...this.dikes.brickOptions,
                    rotation: new THREE.Euler(0, 0, Math.PI * 0.5)
                },
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x - 14, this.y + 10, 0),
                    offsetWidth: new THREE.Vector3(1.05, 0, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: false,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x - 15, this.y + 8, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })

        this.walls.add({
            object: this.dikes.brickOptions,
            shape:
                {
                    type: 'brick',
                    equilibrateLastLine: true,
                    widthCount: 3,
                    heightCount: 2,
                    position: new THREE.Vector3(this.x - 15, this.y + 2.5, 0),
                    offsetWidth: new THREE.Vector3(0, -1.05, 0),
                    offsetHeight: new THREE.Vector3(0, 0, 0.45),
                    randomOffset: new THREE.Vector3(0, 0, 0),
                    randomRotation: new THREE.Vector3(0, 0, 0.2)
                }
        })
    }
}
